<template>
  <div class="container-register-kit">
    <h5>Olá!<br>
    Chegou a hora de registrar <br/>o kit e realizar o seu cadastro!</h5>
    <p>É rápido, seguro e você ja começa a ter mais saúde.</p>
	  <div class="split"></div>
    <h4>Registrar KIT</h4>
    <form @submit="handleSubmit" class="form">
      <div class="input-box">
        <label for="kit_number">Inserir número do KIT *</label>
        <input
        type="text"
        name="kit_number"
        id="kit_number"
        v-model="form.kit_number"/>
        <small class="error" v-if="errors && errors.kit_number">{{errors.kit_number.join()}}</small>
      </div>
      <button class="button btn-primary" v-if="!loading" @click="handleSubmit">Salvar e Próximo</button>
      <button class="button btn-primary" v-if="loading" @click="handleSubmit" disabled><loading /></button>
    </form>
  </div>
</template>

<script>
  import {POST_KIT_VALIDATE} from "../../services/kit";

  export default {
    props: ['next'],
    name: "KitNumber",
    data: () => ({
      loading: false,
      errors: [],
      form: {
        kit_number: "",
        verify: true,
        verified: false,
      }
    }),
    methods: {
      clearErrors() {
        this.errors = [];
      },
      handleSubmit(event) {
        event.preventDefault();
        this.clearErrors();
        this.loading = true;
        POST_KIT_VALIDATE(this.form)
			.then(
				resp => {
          console.log(resp);
					this.form.verified = resp.data.step,
					this.form.shipping_type = resp.data.shipping_type,
					this.form.tag_type = resp.data.tag_type,
					this.$emit('next', this.form);
				},
				error => this.errors = error.response.data,
			).then(
				resp => {
					console.log(this.errors);
					this.loading = false;
				}
			);
      }
    },
    mounted() {
        let url_string = window.location.href;
        let url = new URL(url_string);
        let kit = url.searchParams.get("kit_number");
        if(kit && kit != '')
          this.form.kit_number = kit;
    }
  }
</script>

<style scoped>
	.container-register-kit {
		max-width: 480px;
		margin: 0 auto;
	}
	.input-box {
		margin-bottom: 1.7rem;
	}
	form {
		margin-top: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/KitNumber.vue